export const intlPtBr = {
    测试: 'teste',
    登录: 'Entrar',
    注册: 'Registrar',
    变量的例子: 'Exemplo de variável {value}',
    多样式多语言例子: '<span style="font-size: 12px;color: #d7cab3;">Exemplo de variável <span style="font-size: 16px;color: #fff;font-weight: 600;">@money</span></span>',
    体育: 'Esportes',
    存款: 'Depósito',
    提款: 'Retirada',
    请登录: 'Por favor, faça o login',
    余额刷新成功: 'Saldo atualizado com sucesso',
    我的金额: 'Meu dinheiro',
    我的邀请码: 'Meu código de convite',
    复制成功: 'Copiado com sucesso',
    下一次抽奖: 'Próximo sorteio',
    您没有抽奖的机会: 'Você não tem chance de sorteio',
    规则: 'Regras',
    我的: 'Meu',
    我的信息: 'Minha informação',
    资金详情: 'Detalhes do dinheiro',
    在线客服: 'Atendimento ao cliente online',
    客服暂未配置: 'Atendimento ao cliente não configurado',
    促销码: 'Código promocional',
    请输入促销码: 'Por favor insira o código promocional',
    验证码: 'Código de verificação',
    请输入验证码: 'Por favor insira o código de verificação',
    提交: 'Enviar',
    退出登录: 'Sair',
    提示: 'Dica',
    '确定要退出登录吗？': 'Tem certeza de que deseja sair?',
    取消: 'Cancelar',
    确定: 'Confirmar',
    '升级到 {value} 还需要 {value}': 'Atualizar para {value1} ainda precisa de {value2}',
    头像: 'Avatar',
    用户名: 'Nome de usuário',
    登录密码: 'Senha de login',
    提现密码: 'Senha de retirada',
    修改提现密码: 'Alterar senha de retirada',
    修改密码: 'Alterar senha',
    设置提现密码: 'Definir senha de retirada',
    请输入提现密码: 'Por favor insira a senha de retirada',
    请再次输入提现密码: 'Por favor insira a senha de retirada novamente',
    提现密码不能为空: 'A senha de retirada não pode estar vazia',
    确认提现密码不能为空: 'A confirmação da senha de retirada não pode estar vazia',
    提现密码格式不正确: 'Formato de senha de retirada incorreto',
    确认提现密码格式不正确: 'Formato de confirmação de senha de retirada incorreto',
    提现密码和确认提现密码不一致: 'A senha de retirada e a confirmação da senha de retirada não são iguais',
    设置提现密码成功: 'Definir senha de retirada com sucesso',
    请输入旧密码: 'Por favor insira a senha antiga',
    请输入新密码: 'Por favor insira a nova senha',
    请再次输入新密码: 'Por favor insira a nova senha novamente',
    旧密码不能为空: 'A senha antiga não pode estar vazia',
    新密码不能为空: 'A nova senha não pode estar vazia',
    确认密码不能为空: 'A confirmação da senha não pode estar vazia',
    '旧密码格式不正确, 请输入6-18位字母或数字': 'Formato de senha antiga incorreto, insira 6-18 caracteres alfanuméricos',
    '新密码格式不正确, 请输入6-18位字母或数字': 'Formato de nova senha incorreto, insira 6-18 caracteres alfanuméricos',
    '确认密码格式不正确, 请输入6-18位字母或数字': 'Formato de confirmação de senha incorreto, insira 6-18 caracteres alfanuméricos',
    新密码和确认密码不一致: 'Nova senha e confirmação de senha não são iguais',
    '修改密码成功, 请重新登录': 'Senha alterada com sucesso, faça login novamente',
    修改提现密码成功: 'Senha de retirada alterada com sucesso',
    选择头像: 'Escolha um avatar',
    今天: 'Hoje',
    昨天: 'Ontem',
    一个月内: 'Dentro de um mês',
    余额: 'Saldo',
    编号: 'Número de identificação',
    备注: 'Observação',
    提现金额: 'Quantia retirada',
    充值: 'Recarregar',
    账变: 'Mudança de conta',
    所有类型: 'Todos os tipos',
    每天: 'Diariamente',
    每周: 'Semanalmente',
    每月: 'Mensalmente',
    活动名称: 'Nome do evento',
    优惠金额: 'Quantia de desconto',
    申请时间: 'Tempo de aplicação',
    '发放/审核时间': 'Tempo de emissão/auditoria',
    状态: 'Estado',
    活动奖项: 'Prêmios do evento',
    排名: 'Classificação',
    每日列表: 'Lista diária',
    每周列表: 'Lista semanal',
    每月列表: 'Lista mensal',
    没有排名: 'Sem classificação',
    我的投注: 'Minhas apostas',
    我的奖励: 'Minhas recompensas',
    剩余排名: 'Classificação restante',
    空缺: 'Vazio',
    奖励: 'Recompensa',
    总投注: 'Apostas totais',
    投注: 'Aposta',
    '占所有玩家总投注额的 {value} %': 'Apostas totais de todos os jogadores {value} %',
    暂无数据: 'Sem dados',
    首页: 'Página inicial',
    优惠活动: 'Promoções',
    推广: 'Promoção',
    请选择: 'Por favor escolha',
    年: 'Ano',
    月: 'Mês',
    日: 'Dia',
    上午: 'Manhã',
    下午: 'Tarde',
    天: 'Dia',
    周: 'Semana',
    投注返利详情:
        '<span style="font-size: 10px;color: #d7cab3;">O valor total da aposta do seu time é {value1},e você pode ganhar até <span style="font-size: 14px;color: #fff;font-weight: 600;">{value1}</span> por mês.</span>',
    优惠活动详情: 'Detalhes da promoção',
    活动申请: 'Aplicativo de atividade',
    加载中: 'Carregando',
    申请: 'Aplicar',
    申请成功: 'Aplicativo bem-sucedido',
    申请失败: 'Aplicativo falhou',
    所有记录: 'Todos os registros',
    申请中: 'Aplicação',
    发放成功: 'Emissão bem-sucedida',
    审核失败: 'Revisão falhou',
    活动申请记录: 'Registros de aplicativo de atividade',
    原因: 'Motivo',
    邮件: 'Correio',
    邮件最多可保存30天: 'Correios podem ser salvos por até 30 dias',
    删除已读: 'Excluir Ler',
    全部接收: 'Receber todos',
    邮件详情: 'Detalhes do e-mail',
    删除: 'Excluir',
    确认密码: 'Confirmar senha',
    真实姓名: 'Nome real',
    姓: 'Sobrenome',
    名: 'Primeiro nome',
    邮箱: 'E e-mail',
    邮箱验证码: 'Código de verificação de e-mail',
    发送: 'Enviar',
    手机号: 'Número de celular',
    手机验证码: 'Código de verificação de celular',
    出生日期: 'Data de nascimento',
    twitter: 'twitter',
    facebook: 'facebook',
    证件类型: 'Tipo de ID',
    证件号: 'Número de ID',
    推广码: 'Código de promoção',
    优惠码: 'código de resgate',
    登录成功: 'Login bem sucedido',
    登录失败: 'Falha no login',
    登录账号: 'Conta de login',
    请输入正确的邮箱: 'Por favor insira um endereço de e-mail válido',
    请选择手机区号: 'Por favor selecione um código de área móvel',
    手机号校验: 'Por favor insira um Número de celular de 6 a 12 dígitos',
    请输入10位手机号: 'Por favor insira um Número de celular de 10 dígitos',
    验证码发送成功: 'Código de verificação enviado com sucesso',
    用户名验证: 'O nome de usuário deve começar com (6-15) letras e uma combinação de letras minúsculas e números',
    用户名不能以test为起始: 'O nome de usuário não pode começar com teste',
    密码必须为6位数字: 'A senha deve ter 6 dígitos',
    确认密码必须为6位数字: 'A confirmação da senha deve ter 6 dígitos',
    两次输入的密码不一致: 'Digite duas vezes A senha não corresponde.',
    登录密码验证: 'A senha deve ser uma combinação de (6 a 18 caracteres) de letras, números ou caracteres especiais',
    确认登录密码验证: 'Confirme que a senha deve ser uma combinação de (6 a 18 caracteres) de letras, números ou caracteres especiais',
    请输入正确的姓名: 'Por favor insira seu nome correto',
    请输入出生日期: 'Por favor insira sua data de nascimento',
    请输入您的twitter账号: 'Por favor insira sua conta do {value}',
    请输入您的facebook账号: 'Por favor insira sua conta do Facebook',
    推广码校验: 'Confirme que você inseriu o código promocional correto (1 a 8 dígitos)',
    推广码校验2: 'Insira o código promocional',
    请点击开始验证: 'Clique em Iniciar verificação',
    请输入邮箱验证码: 'Insira o código de verificação de e-mail',
    请输入手机验证码: 'Insira o código de verificação do celular',
    请输入姓: 'Insira seu sobrenome',
    请输入名: 'Insira seu primeiro nome',
    请输入证件号: 'Insira seu número de identificação',
    请输入有效的CURP: 'Insira um CURP válido',
    '请输入11~14位数字': 'Insira de 11 a 14 dígitos',
    请选择证件类型: 'Por favor, selecione o tipo de ID',
    请接受服务条款: 'Por favor, aceite os termos de serviço',
    邀请奖励: 'Convite Rewards',
    问题1: 'Q1: O que significa divisão de comissão?',
    回答1: 'A1: Depois de convidar amigos para participar do aplicativo e vincular seu código de convite, você receberá uma comissão adicional com base no consumo desses amigos em uma determinada proporção. ',
    问题2: 'Q2: O que significa clube?',
    回答2: 'A2: Seu clube consiste em todos os membros da sua equipe de agentes.',
    问题3: 'Q3: Como posso atualizar para uma classificação de estrelas de clube mais alta?',
    回答3: 'A3: Você pode atualizar convidando mais amigos ou consumindo coletivamente com membros da equipe. Para obter informações mais detalhadas, consulte a tabela de requisitos de atualização.',
    问题4: 'Q4: Como posso receber recompensas?',
    回答4: 'A4: Assim que seus amigos ou os convites de seus amigos fizerem compras, você receberá imediatamente todas as recompensas, que serão depositadas em sua conta de comissão e podem ser sacados para sua carteira no dia seguinte.',
    问题5: 'Q5: Há algum requisito de aposta para sacar recompensas?',
    回答5: 'A5: Há um requisito de aposta único.',
    问题6: 'Q6: Quando posso usar minhas recompensas?',
    回答6: 'A6: Você pode sacar suas recompensas para seu carteira para gastar no dia seguinte. Às vezes pode haver pequenos atrasos. Obrigado pela sua compreensão.',
    佣金比例详情: '※Você pode receber uma certa porcentagem de comissão de todas as apostas e valores de recarga feitos por A, B e C. Consulte o diagrama a seguir para taxas de comissão específicas.',
    返利比例详情: '※Jogos diferentes têm descontos diferentes. índices. Você também pode aumentar a proporção de descontos atualizando a classificação por estrelas do seu clube.',
    立即邀请: 'Convide agora!',
    佣金率: 'Taxa de comissão',
    流水返利: 'Rebate no volume de negócios',
    俱乐部之星: 'Estrelas do clube',
    佣金等级: 'Comissão nível {value}',
    首存返利: 'Desconto no primeiro depósito',
    什么是俱乐部: 'O que é um clube?',
    俱乐部的星级越高介绍: 'Você e todos os seus agentes formam o seu clube. Quanto maior a classificação por estrelas do clube, maior a taxa de desconto.',
    你的俱乐部: 'Seu clube',
    如何提高俱乐部的星级: 'Como aumentar a classificação por estrelas do clube?',
    代理要求: 'Requisitos do agente',
    投注要求: 'Requisitos de apostas',
    无星: 'Nenhuma estrela',
    一星: 'Uma estrela',
    二星: 'Duas estrelas',
    三星: 'Três estrelas',
    全部: 'Todos',
    我的奖金: 'Meu ​​bônus',
    下一级: 'Próximo nível',
    累计存款: 'Acumular depósito {value}',
    每日提款限额: 'Limite de saque diário',
    每日提现次数: 'Quantidade de saques diários',
    每月累计存款升级VIP等级: 'Depósito cumulativo mensal Um upgrade Nível VIP',
    等级: 'Nível',
    月度奖金: 'Bônus mensal',
    等级升级奖励: 'Bônus de atualização',
    现金奖励发放时间: 'Melhoria de nível bônus e bônus em dinheiro: com base no seu Nível VIP no final deste mês, esta recompensa será enviada a você às 10h. no dia primeiro do próximo mês.',
    晋级彩金: 'Bônus mensal',
    每月奖金: 'Desconto de aposta',
    投注返水: 'Desconto de apostas',
    网络问题: 'Problema de rede',
    '检测到您目前没有网络连接，请开启网络后再试。': 'Detectamos que você não tem conexão de rede no momento, por favor, abra a rede e tente novamente.',
    设置: 'Configurações',
    总奖励: 'Total de recompensas',
    邀请总数: 'Total de convites',
    邀请有效用户数量: 'Você convidou um total de {value1} amigos, dos quais {value2} são usuários válidos.',
    邀请新客户获得: 'Convide um novo cliente get',
    邀请好友可获得: 'Amigos convidados get',
    邀请好友获取金钱: 'Convide amigos para ganhar dinheiro',
    每日邀请次数: 'Tempos de convite diários: {value}',
    邀请300位好友可获得: 'Invite {value} friends get',
    如何参与: 'COMO PARTICIPAR',
    步骤1: 'Etapa 1: Registre-se',
    步骤2: 'Etapa 2: Clique em qualquer página de convite para convidar amigos',
    步骤3: 'Etapa 3: Amigos registrem-se e digitem o código de convite',
    步骤4: 'Etapa 4: Depósitos de amigos @valor',
    步骤5: 'Etapa 5: Receba recompensas',
    什么是有效邀请用户: 'O QUE É UM USUÁRIO CONVIDADO VÁLIDO?',
    有效邀请用户描述: 'Um usuário convidado válido é alguém que tem depositou um valor cumulativo maior que {value}',
    奖励兑换: 'REWARD REDEMPTION',
    奖励兑换步骤1: 'Para cada convite bem-sucedido, o convidante recebe {value1}.',
    奖励兑换步骤2: 'O agente direto (superior do convidante) recebe um bônus de {value}.',
    奖励兑换步骤3: 'O agente superior do agente direto recebe um bônus de {value}.',
    奖励兑换步骤4: 'O usuário convidado também recebe um bônus de {value}.',
    奖励兑换步骤5: 'A recompensa pode ser usada para jogar.',
    奖励兑换步骤6: 'As recompensas são distribuídas automaticamente pelo sistema.',
    活动解释权: '{value} mantém o direito final de interpretação desta atividade.',
    '安装权限未被授予，无法打开APK文件': 'Permissão de instalação não concedida, incapaz de abrir o arquivo APK',
    '权限已授予，正在尝试打开APK...': 'Permissão concedida, tentando abrir o APK...',
    立即更新: 'Atualizar agora',
    稍后更新: 'Atualizar mais tarde',
    版本号不符合规范: 'Número da versão não está em conformidade com as especificações',
    邀请人数: 'Contagem de convites',
    奖励详情: 'Detalhes da recompensa',
    '网络错误, 请稍后重试!': 'Erro de rede, tente novamente mais tarde!',
    存款金额: 'Valor do depósito',
    奖励金额: 'Valor da recompensa',
    立即存款: 'Depósito agora',
    今天不再显示: 'Não mostrar novamente hoje',
    倒计时: 'contagem regressiva',
    应用未安装: 'Aplicativo não instalado',
    邀请码: 'Código de convite',
    请输入用户名: 'Por favor insira o nome de usuário',
    密码: 'Senha',
    请输入密码: 'Por favor insira a senha',
    '密码必须为(6~18位)字母或数字组合': 'A senha deve ser uma combinação de (6 a 18 caracteres) de letras ou números',
    忘记密码: 'Esqueceu a senha',
    注册账号: 'Registrar conta',
    重置密码: 'Redefinir senha',
    '确定进入游戏吗?': 'Tem certeza de que deseja entrar no jogo?',
    进入游戏失败: 'Falha ao entrar no jogo',
    '确定要支付吗?': 'Tem certeza de que deseja pagar?',
    充值请求已取消: 'Solicitação de recarga cancelada',
    已提交充值请求: 'Solicitação de recarga enviada',
    存款方式: 'Método de depósito',
    存款账户: 'Conta de depósito',
    收款户名: 'Nome do beneficiário: ',
    银行账户: 'Conta bancária: ',
    开户地址: 'Endereço da agência: ',
    开户银行: 'Banco da conta: ',
    单笔范围: 'Intervalo por transação: ',
    存款优惠: 'Bônus de depósito',
    最高奖金: 'Bônus máximo: ',
    剩余数量: 'Quantidade restante: ',
    不选择: 'Não escolher',
    请选择优惠: 'Selecione o bônus',
    充值优惠详情: 'Detalhes do bônus de recarga',
    详情: 'Detalhes',
    最小额: 'Mín',
    最大额: 'Máx',
    存款提示: 'Dicas de depósito',
    存款提示1: 'Cada depósito será creditado em 1-5 minutos',
    存款提示2: 'Você pode entrar em contato com o atendimento ao cliente a qualquer momento para resolver problemas de depósito',
    充值金额不能小于最小金额: 'O valor da recarga não pode ser inferior ao valor mínimo',
    立即支付: 'Pagar agora',
    下一步: 'Próximo passo',
    USDT数量: 'Quantidade de USDT',
    充值金额: 'Valor da recarga',
    复制: 'Copiar',
    TXID后五位: 'Últimos cinco dígitos do TXID',
    汇款信息: 'Informações de remessa',
    '(必填)请输入汇款人姓名或者卡号后四位': '(Obrigatório) Insira o nome do remetente ou os últimos quatro dígitos do cartão',
    上一步: 'Passo anterior',
    备注信息不允许为空: 'As informações de observação não podem estar vazias',
    收款银行: 'Banco receptor',
    银行地址: 'Endereço do banco',
    PIX类型: 'Tipo de PIX',
    账号名称: 'Nome da conta',
    收款账户: 'Conta de recebimento',
    PIX账号: 'Conta PIX',
    选择钱包类型: 'Selecione o tipo de carteira',
    '获取钱包列表失败, 请联系客服': 'Falha ao obter a lista de carteiras, entre em contato com o atendimento ao cliente',
    请选择钱包类型: 'Selecione o tipo de carteira',
    收款地址: 'Endereço de recebimento',
    当前汇率: 'Taxa de câmbio atual',
    转换金额: 'Valor da conversão',
    单日提现金额上限: 'Limite diário de saque: ',
    单日提现次数上限: 'Limite diário de saques: ',
    单笔最低提现额度: 'Limite mínimo de saque por transação: ',
    单笔最高提现额度: 'Limite máximo de saque por transação: ',
    提现时间段: 'Período de saque: ',
    普通余额: 'Saldo comum: ',
    代理余额: 'Saldo de agente: ',
    普通余额可兑换USDT数量: 'Quantidade de USDT que pode ser trocada com saldo comum: ',
    代理余额可兑换USDT数量: 'Quantidade de USDT que pode ser trocada com saldo de agente: ',
    '你还没绑定三方钱包哦!': 'Você ainda não vinculou uma carteira de terceiros!',
    选择钱包: 'Selecionar carteira',
    请输入提现金额: 'Insira o valor do saque',
    请输入有效金额: 'Insira um valor válido',
    请输入正整数金额: 'Insira um valor inteiro positivo',
    普通余额不足: 'Saldo comum insuficiente',
    代理余额不足: 'Saldo de agente insuficiente',
    请选择三方钱包: 'Selecione a carteira de terceiros',
    '你还没虚拟货币地址哦!': 'Você ainda não tem um endereço de criptomoeda!',
    请输入要兑换的USDT数量: 'Insira a quantidade de USDT a ser trocada',
    请输入有效枚数: 'Insira uma quantidade válida',
    请输入正整数枚数: 'Insira uma quantidade inteira positiva',
    提款数量不能大于可提款USDT数量: 'A quantidade de saque não pode ser maior do que a quantidade de USDT disponível para saque',
    请输入提款金额: 'Insira o valor do saque',
    请选择钱包: 'Selecione a carteira',
    '你还没绑定银行卡哦!': 'Você ainda não vinculou um cartão bancário!',
    选择银行卡: 'Selecionar cartão bancário',
    请选择银行卡: 'Selecione o cartão bancário',
    '你还没绑定PIX哦!': 'Você ainda não vinculou um Pix!',
    选择PIX: 'Selecionar Pix',
    请选择PIX类型: 'Selecione o tipo de Pix',
    '你还没绑定支付宝哦!': 'Você ainda não vinculou um Alipay!',
    选择支付宝: 'Selecionar Alipay',
    请选择支付宝: 'Selecione o Alipay',
    去绑定: 'Vincular',
    已选: 'Selecionado',
    兑换全部: 'Trocar tudo',
    当前提款不在时间段内: 'Saque atual fora do período permitido',
    钱包中心: 'Centro de carteira',
    绑卡提示: 'Caro usuário, para sua segurança, por padrão, você só pode vincular {value} cartões. Se precisar remover ou modificar, entre em contato com o atendimento ao cliente',
    钱包地址: 'Endereço da carteira',
    请输入钱包地址: 'Insira o endereço da carteira',
    请输入字母或数字: 'Insira letras ou números',
    钱包姓名: 'Nome da carteira',
    请输入钱包姓名: 'Insira o nome da carteira',
    持卡人姓名: 'Nome do titular do cartão',
    钱包名称: 'Nome da carteira',
    钱包账号: 'Conta da carteira',
    开户行地址: 'Endereço da agência bancária',
    钱包类型: 'Tipo de carteira',
    "TRC20需以字母'T'开头的34位字符": "TRC20 deve começar com a letra 'T' e conter 34 caracteres",
    银行卡类型: 'Tipo de cartão bancário',
    请选择银行卡类型: 'Selecione o tipo de cartão bancário',
    请输入开户行地址: 'Insira o endereço da agência bancária',
    已有银行卡号: 'Número do cartão bancário existente',
    请输入已有银行卡号: 'Insira o número do cartão bancário existente',
    银行卡账号: 'Conta do cartão bancário',
    请输入银行卡账号: 'Insira a conta do cartão bancário',
    请输入持卡人姓名: 'Insira o nome do titular do cartão',
    银行名称: 'Nome do banco',
    银行账号: 'Conta bancária',
    支付宝姓名: 'Nome no Alipay',
    请输入支付宝姓名: 'Insira o nome no Alipay',
    支付宝账号: 'Conta Alipay',
    请输入支付宝账号: 'Insira a conta Alipay',
    添加新账户: 'Adicionar nova conta',
    资料信息提交成功: 'Informações enviadas com sucesso',
    联系地址: 'Endereço de contato',
    请输入联系地址: 'Insira o endereço de contato',
    完善信息: 'Informação completa',
    请先完善个人信息: 'Por favor, preencha as informações pessoais',
    请先选择优惠: 'Por favor, selecione o desconto',
    请输入PIX账号: 'Insira o PIX',
    活动金额: 'Quantia da atividade',
    更换成功: 'Substituição bem-sucedida',
    注册成功: 'Registro bem sucedido',
    注册失败: 'registração falhou',
    请选择线路: 'Selecione a linha',
    '线路{value}': 'Linha {value}',
    存款前请先绑定银行卡: 'Depositar antes de vincular o cartão bancário',
    额度回收: 'Recuperação de limite',
    一键刷新: 'atualização com um clique',
    一键回收: 'reciclagem com um clique',
    主平台金额: 'montante da plataforma principal',
    我的团队俱乐部: 'Clube da Minha Equipa',
    俱乐部星级: 'Classificação por estrelas do clube',
    俱乐部星级提示: 'Quanto maior a classificação por estrelas do clube, maior a taxa de desconto',
    俱乐部成员: 'Membros do clube',
    俱乐部投注: 'Apostas do clube',
    我的返佣: 'Minha comissão',
    投注返佣高达: 'Comissão de apostas de até',
    首次存款返佣: 'Comissão de depósito pela primeira vez',
    可领取: 'Pode receber',
    领取: 'Receber',
    领取成功: 'Recebido com sucesso',
    领取失败: 'Falha ao receber',
    今日奖励: 'Recompensa de hoje',
    邀请朋友: 'Convide amigos',
    通过WhatsApp邀请: 'Convide via WhatsApp',
    保存图片: 'Salvar imagem',
    分享: 'Compartilhar',
    从属数据: 'Dados subordinados',
    总人数: 'Número total de pessoas',
    本月: 'Este mês',
    层级: 'Nível',
    加入时间: 'Tempo de adesão',
    佣金: 'Comissão',
    提款历史记录: 'Histórico de saques',
    邀请: 'Convite',
    邀请任务: 'Tarefa de convite',
    时间: 'Tempo',
    佣金金额: 'Quantia da comissão',
    成功: 'Sucesso',
    下级: 'Subordinado',
    受邀人数: 'Número de convidados',
    佣金总额: 'Total de comissões',
    提现公告: '{value1} retira {value2} com sucesso',
    个人资料: 'Perfil',
    用户信息: 'Informações do usuário',
    昵称: 'Nome de usuário',
    今天1: 'Hoje',
    昨天1: 'Ontem',
    奖励详情1: 'Detalhes da recompensa',
    投注1: 'Aposta',
    存款1: 'Depósito',
    状态1: 'Estado',
    邀请奖励高达: 'Recompensa de convite de até',
    平台名称: 'Nome da Plataforma',
    金额: 'Quantia',
    刷新: 'Atualizar',
    回收: 'Reciclar',
    休眠提示: 'Cliques muito frequentes, por favor tente novamente após {value} segundos',
    刷新成功: 'Atualização bem-sucedida',
    刷新失败: 'Falha na atualização',
    回收成功: 'Reciclagem bem-sucedida',
    回收失败: 'Falha na reciclagem',
    存款提示3: '1. Cada depósito será creditado dentro de 1 a 5 minutos.',
    存款提示4: '2. Você pode entrar em contato com o atendimento ao cliente a qualquer momento para resolver problemas de depósito.',
    提款提示: 'Dicas de saque',
    提款提示1: 'Em circunstâncias normais, o valor do saque chegará à sua conta em cerca de 2 horas, e o prazo máximo não excederá 24 horas',
    钱包: 'Carteira',
    我的余额: 'Meu Saldo',
    绑定手机号: 'Vincular número de telefone',
    绑定成功: 'Vinculação bem-sucedida',
    未绑定: 'Desvinculado',
    验证码发送失败: 'Falha no envio do código de verificação',
    投注记录: 'Registro de apostas',
    投注金额: 'Quantia da aposta',
    投注时间: 'Tempo da aposta',
    订单号: 'Número do pedido',
    平台: 'Plataforma',
    游戏名: 'Nome do jogo',
    玩法: 'Jogar',
    投注模式: 'Modo de aposta',
    有效投注: 'Aposta válida',
    盈亏金额: 'Lucro e perda',
    '1、功能优化、性能优化': '1. Otimização de funções e desempenho',
    '2、修复一些已知问题': '2. Corrigir alguns problemas conhecidos',
    发现新版本: 'Nova versão encontrada',
    奖励2: 'Recompensa',
    下一次免费旋转: 'Próxima Rodada Grátis',
    请输入正确的IFSC码: 'Insira o código IFSC correto',
    记录: 'Rekam',
    提款剩余时间: 'Waktu penarikan tersisa ',
    收集提现: 'Untuk menarik saat Anda mengumpulkan {value}',
    剩余提现额: '<span style="font-size: 13px;color: #ffffff;">hanya <span style="font-size: 13px;color: #e9b742;">{value}</span> yang bisa digunakan</span>',
    邀请好友获得免费旋转: 'Undang teman untuk mendapatkan Putaran Gratis',
    选择您的奖励: 'Pilih hadiah Anda',
    每日免费提款: 'Saques diários gratuitos',
    所有时间: 'Sempre',
    本周: 'Minggu ini',
    上周: 'Minggu lalu',
    QQ: 'QQ',
    微信: 'WeChat',
    telegram: 'telegram',
    whatsApp: 'whatsApp',
    line: 'line',
    instagram: 'Instagram',
    手机号格式不正确: 'O formato do número de telefone está incorreto',
    请输入真实姓名: 'Por favor insira seu nome real',
    不限制: 'sem limite',
    请输入订单号: 'Por favor insira o número do pedido',
    立即游戏: 'Jogue agora',
    '存款 {value} 即可获得 {value} 次旋转。': 'Deposite {value1} para obter {value2} rodadas.',
    '1次': '{value} vez',
    历史: 'Histórico',
    活动规则: 'Regras da atividade',
    游戏维护中: 'O jogo está em manutenção',
    游戏维护时间: 'O jogo está em manutenção, horário de manutenção:{value}',
    快捷登录: 'Login rápido',
    绑定Google账号: 'Vincular conta do Google',
    绑定失败: 'Falha na vinculação',
    支持: 'Suporte',
    更多: 'Mais',
    提现次数: '{value} vezes',
    '请安装Google Play服务': 'Instale o Google Play Services',
    '暂无相册权限，请前往设置开启权限': 'Sem permissão de álbum, vá para configurações para abrir a permissão',
    '暂无相机权限，请前往设置开启权限': 'Sem permissão de câmera, vá para configurações para abrir a permissão',
    '暂无麦克风权限，请前往设置开启权限': 'Sem permissão de microfone, vá para configurações para abrir a permissão',
    '暂无手机存储权限，请前往设置开启权限': 'Sem permissão de armazenamento, vá para configurações para abrir a permissão',
    请输入IFSC码: 'Por favor insira o código IFSC',
    搜索: 'procurar',
    恭喜你: 'Parabéns',
    用户名或手机号码: 'nome de usuário ou número de celular',
    请输入用户名或手机号码: 'Por favor, insira seu nome de usuário ou número de celular',
    玩法说明: 'Regras do jogo',
    截止时间: 'Hora de término',
    随机投注: 'Aposta aleatória',
    游戏记录: 'Registro de jogo',
    图表趋势: 'Tendência do gráfico',
    我的投注记录: 'Meu registro de apostas',
    期号: 'Número do período',
    '大/小': 'Grande/Pequeno',
    数字: 'Número',
    颜色: 'Cor',
    大: 'Grande',
    小: 'Pequeno',
    '投注助手（过去100期）': 'Assistente de apostas (últimos 100 períodos)',
    开奖号码: 'Número do sorteio',
    数量: 'Quantidade',
    我同意: 'Eu concordo',
    预售规则详情:
        'A fim de proteger os direitos e interesses legítimos dos usuários que participam da pré-venda e manter a ordem operacional normal, as regras são implementadas de acordo com os acordos e regulamentos relevantes. 1.1 Definição de pré-venda: refere-se ao modelo de vendas em que os comerciantes fornecem soluções de produtos ou serviços, coletam pedidos de consumidores por meio de ferramentas de pré-venda de produtos e fornecem bens ou serviços aos consumidores de acordo com acordos prévios. 1.2 O modelo de pré-venda-venda é um modelo de "depósito". "Depósito" refere-se ao valor fixo no preço de pré-venda das mercadorias entregues antecipadamente. "Depósito" pode participar de minijogos e ter a chance de ganhar mais depósitos. Os depósitos podem ser trocados diretamente por mercadorias. 1.3 Produtos de pré-venda: Refere-se aos produtos divulgados pelos lojistas por meio da ferramenta de pré-venda. Marque apenas a palavra pré-venda no título do produto ou na página de detalhes do produto, e os produtos que não utilizam a ferramenta de pré-venda do produto não são classificados como produtos de pré-venda. 1.4 Sistema de pré-venda: refere-se à ferramenta de produto do sistema fornecida para apoiar os comerciantes na pré-venda - vendas modelo de venda 1.5 Preço do produto em pré-venda: refere-se ao preço de venda dos produtos em pré-venda. O preço dos produtos de pré-venda consiste em duas partes: depósito e pagamento final.',
    预售规则: 'Regras de pré-venda',
    总金额: 'Quantia total',
    投注金额必须大于0: 'A quantia da aposta deve ser maior que 0',
    请同意预售规则: 'Por favor, concorde com as regras de pré-venda',
    投注小于最小限额: 'A aposta é menor que o limite mínimo',
    投注大于最大限额: 'A aposta é maior que o limite máximo',
    当前期已封盘: 'O período atual está fechado',
    请选择投注内容: 'Selecione o conteúdo da aposta',
    投注失败: 'Falha na aposta',
    投注成功: 'Aposta bem-sucedida',
    红色: 'Vermelho',
    绿色: 'Verde',
    紫色: 'Roxo',
    购买金额: 'Quantia da compra',
    购买数量: 'Quantidade da compra',
    税后金额: 'Quantia após impostos',
    税收: 'Imposto',
    结果: 'Resultado',
    选择: 'Selecionar',
    '输/赢': 'Perder/Ganhar',
    创建时间: 'Tempo de criação',
    'WIN GO彩票': 'WIN GO Loteria',
    'WIN GO规则详情':
        'Se você gastar 100 para negociar, após deduzir 2 taxas de serviço, o valor do seu contrato é 98:<br/><br/>1. Selecione verde: se o resultado mostrar 1,3,7,9, você receberá (98*2) 196;Se o resultado mostrar 5, você obterá (98*1,5) 147<br/><br/>2. Selecione vermelho:   se o resultado mostrar 2,4,6,8, você obterá (98*2) 196;Se o resultado mostrar 0, você obterá (98*1,5) 147<br/><br/>3. Selecione violeta: se o resultado mostrar 0 ou 5, você receberá (98*4,5) 441<br/><br/>4. Selecione o número: se o resultado for o mesmo que o número selecionado, você receberá (98*9) 882<br/><br/>5. Selecione grande: se o resultado mostrar 5,6,7,8,9 você obterá (98 * 2) 196<br/><br/>6. Selecione pequeno: se o resultado mostrar 0,1,2,3,4, você obterá (98 * 2) 196',
    该玩法不允许下注: 'Esta jogada não permite apostas',
    总赌注: 'Aposta total',
    赔率: 'Probabilidade',
    选择3个唯一号码: 'Selecione 3 números exclusivos',
    '*如果开盘号码与3个投注号码匹配，则中奖。': '*Se o número de abertura corresponder a 3 números de aposta, você ganhará.',
    '*如果开奖号码是相同号码中的任意三个，则中奖。': '*Se o número de abertura for qualquer um dos três números idênticos, você ganhará.',
    '*如果开盘号码与2个投注号码匹配，则中奖。（三个相同的数字除外）。': '*Se o número de abertura corresponder a 2 números de aposta, você ganhará. (Exceto três números idênticos).',
    选择2个相同的数字: 'Selecione 2 números idênticos',
    选择一对独特的数字: 'Selecione um par de números exclusivos',
    '选择至少1对相同号码和1对不同号码进行投注，如果开盘号码与投注号码相符，则中奖。':
        'Selecione pelo menos 1 par de números idênticos e 1 par de números exclusivos para apostar. Se o número de abertura corresponder ao número de aposta, você ganhará.',
    选择2个不同的数字: 'Selecione 2 números exclusivos',
    选择3个不同的数字: 'Selecione 3 números exclusivos',
    '*选择3个或更多不同的数字。所抽中的3个号码若不同且符合选择，则中奖':
        '*Selecione 3 ou mais números exclusivos. Se os 3 números sorteados forem diferentes e corresponderem à sua seleção, você ganhará',
    '*选择2个或更多不同的号码。 如果抽取的2个号码不同且符合选择，则中奖。':
        '*Selecione 2 ou mais números exclusivos. Se os 2 números sorteados forem diferentes e corresponderem à sua seleção, você ganhará.',
    '*若开奖号码为三个连续号码，则中奖。': '*Se o número de abertura for três números consecutivos, você ganhará.',
    玩法提示1: 'Escolha 2 números iguais. Se o resultado do sorteio corresponder à sua seleção, você ganha (a menos que 3 números sejam iguais).',
    玩法提示2: 'Escolha 2 números iguais e 1 número diferente. Se o resultado do sorteio corresponder à sua seleção, você ganha.',
    玩法提示3: 'Escolha 3 números iguais. Se o resultado do sorteio corresponder à sua seleção, você ganha.',
    玩法提示4: 'Escolha quaisquer 3 números iguais. Se o resultado do sorteio for três números iguais, você ganha.',
    玩法提示5: 'Escolha 3 ou mais números diferentes. Se o resultado do sorteio corresponder à sua seleção, você ganha.',
    玩法提示6: 'Escolha quaisquer 3 números consecutivos. Se o resultado do sorteio for quaisquer três números consecutivos, você ganha.',
    玩法提示7: 'Escolha 2 ou mais números diferentes. Se os resultados do sorteio forem números diferentes e corresponderem aos números selecionados, você ganha.',
    K3彩票: 'K3 Loteria',
    K3规则详情:
        'Um sorteio rápido de 3 dados para obter 3 números em cada período, os números dos dados consistem em números naturais de 111 a 666 (nenhum 0), os números dos dados nem sempre são consecutivos, pode adivinhar os dados inteiros ou parte dos dados. <br/><br/>Valor da soma <br/>Adivinhe a soma dos valores numéricos de 3 dados <br/><br/>3 números iguais <br/>Fazer uma aposta em 3 números especiais que são os mesmos (111, 222, ... , 666).<br/><br/>2 números iguais <br/>Fazer uma aposta em 2 números que são os mesmos <br/><br/>2 números iguais + 1 número diferente <br/>Fazer uma aposta em 2 números iguais e 1 número diferente <br/><br/>3 números diferentes <br/>Fazer uma aposta em 3 números diferentes <br/><br/>2 números diferentes <br/>Fazer uma aposta em 2 números diferentes <br/><br/>3 números consecutivos <br/>Fazer uma aposta em 3 números consecutivos <br/>(123, 234, 345, 456)<br/><br/>Pequeno (3-11)<br/>Grande (12-18)',
    总和: 'Soma',
    '奇/偶': 'Ímpar/Par',
    '2个相同': '2 iguais',
    '3个相同': '3 iguais',
    '3个连续': '3 consecutivos',
    不同数字: 'Números diferentes',
    '5D彩票': '5D Loteria',
    '5D规则详情':
        'Desenhar instruções<br/>Número de 5 dígitos (00000-99999) será sorteado aleatoriamente em cada período<br/>por exemplo:<br/>O número do sorteio para este Período é 12345<br/>A=1<br/>B=2<br/>C=3<br/>D=4<br/>E=5<br/>SOMA=A+B+C+D+E=15<br/>Como jogar<br/>Os jogadores podem especificar seis resultados de apostas A, B, C, D, E e a soma<br/>A, B, C, D, E podem ser comprados<br/>Número (0 1 2 3 4 5 6 7 8 9)<br/>Baixo (0 1 2 3 4)<br/>Ímpar (1 3 5 7 9)<br/>Alto (5 6 7 8 9)<br/>Ímpar (1 3 5 7 9)<br/>Par (0 2 4 6 8)<br/>Soma = A+B+C+D+E pode ser comprado<br/>Baixo (0-22)<br/>Alta (23-45)<br/>Ímpar (1 3 ···43 45)<br/>Par (0 2 ···42 44)',
    下拉即可刷新: 'Puxe para baixo para atualizar',
    释放即可刷新: 'Solte para atualizar',
    没有更多了: 'não mais',
    试玩提示: 'Você está entrando em uma experiência de teste; retiradas não estão disponíveis após obter lucro',
    分享链接: 'compartilhar link',
    应用已更新: 'O aplicativo foi atualizado',
    点击确定重启App生效: 'Clique em OK para reiniciar o aplicativo',
    热门: 'Popular',
    最近: 'Recente',
    收藏: 'Favoritos',
    邀请好友帮忙提现: '1.Convide amigos para ajudar com saques',
    向随机玩家发送邀请以提供帮助: '2.Enviar convite para jogador aleatório ajudar',
    通过短信发送消息: 'Enviar Mensagem no ',
    短信: 'SMS',
    今天剩余提款额度: 'Valor restante da retirada de hoje',
    VIP每日限额: 'Limite diário VIP',
    今天剩余提款次数: 'Número de saques restantes hoje',
    VIP每日提款次数: 'Horários de retirada diários VIP',
    单笔最小提款: 'Retirada mínima única',
    单笔最大提款: 'Retirada única máxima',
    USDT地址: 'Endereço USDT',
    今天提款次数已用完: 'O número de saques se esgotou hoje',
    提现提示: 'Dicas de retirada',
    系统异常: 'Exceção do sistema',
    '你好，我们有一份礼物送给你': 'Olá, temos um presente para você',
    请输入礼品代码: 'Por favor, insira o código do presente',
    奖金金额: 'Valor do bônus: {value}',
    关注官方渠道获取代码: 'Siga o canal oficial para obter o código',
    '该金额暂无可用的充值通道,请更换充值金额': 'Não há canal de recarga disponível para este valor. Altere o valor da recarga.',
    联系客服: 'Entre em contato com o atendimento ao cliente',
    上月: 'Mês passado',
    礼物: 'Presentes',
    公链查询: 'Consulta de cadeia pública',
    区块: 'Bloco',
    区块时间: 'Tempo do bloco',
    哈希: 'Hash',
    trx详情:
        'O que é um valor hash?<br/><br/>Qualquer pessoa que conheça os conceitos básicos do Bitcoin será exposta a um conceito, um valor hash. O cabeçalho do bloco do Bitcoin tem um hash do bloco anterior, que é usado para apontar para o bloco anterior.<br/><br/>Hash é a transliteração do inglês hash, também podemos traduzi-lo para hash, então o valor hash também é chamado de valor hash. Um valor hash é um valor calculado com uma função hash (ou função hash/algoritmo hash). Para entender os valores hash, é preciso entender a natureza das funções hash. Uma função hash pode transformar computacionalmente uma entrada de comprimento arbitrário em uma saída de comprimento fixo.<br/><br/>Toda função hash tem a propriedade de que se o valor de entrada for o mesmo, o valor hash de saída será o mesmo. Se os valores de entrada forem diferentes, os hashes de saída geralmente serão diferentes, mas há uma chance muito pequena de uma colisão de hash. Se uma colisão de hash for descartada com uma ligeira alteração no valor de entrada, um valor de hash completamente não relacionado é emitido. Como a função de hash é irreversível e fácil de verificar, é quase impossível reverter o valor de entrada por meio do valor de hash de saída. Se houver um valor de entrada, o valor de hash correspondente pode ser verificado imediatamente.<br/><br/>Portanto, o valor de hash de cada bloco é único, aleatório, inquebrável, infalsificável, o valor de hash do bloco é identificado automaticamente e o registro não pode ser adulterado.<br/><br/>Quantos tipos de USDT existem?<br/><br/>1. Omni-USDT baseado na rede Bitcoin, o endereço de depósito é o endereço BTC e o depósito e a retirada passam pela rede BTC;<br/><br/>2. ERC20-USDT baseado no protocolo Ethereum ERC20, o endereço de depósito é o endereço ETH e o depósito e a retirada passam pela rede ETH;<br/><br/>3. TRC20-USDT com base no protocolo TRON TRC20 e na rede TRX (TRON), o endereço de depósito é o endereço TRON, e o depósito e a retirada passam pela rede TRON.<br/><br/>TrxHash é o hash do bloco TRC20-USDT com base no protocolo TRON TRC20 e na rede TRX (TRON). O último número é usado como resultado da loteria para determinar se você ganhou na loteria (clique em Altura do bloco para ir para a cadeia pública e consultar o hash do bloco exclusivo)<br/><br/>As regras do jogo são as seguintes:<br/><br/>1. 1 sorteio de loteria por 1 minuto, compra em 45 segundos, e o resultado não pode ser comprado em 15 segundos antes da abertura.<br/><br/>2. Compre o desbloqueio durante todo o dia. O número total de compras em um dia é 1440.<br/><br/>3. 3 pontos 1 vez, 5 pontos 1 vez, 10 pontos 1 vez, as regras são as mesmas de 1 ponto 1 vez, exceto que o tempo de sorteio é diferente.<br/><br/>4. O último dígito do hash do bloco é usado como resultado da loteria:<br/><br/>Ex:<br/><br/>Se o valor do hash for **b569, o resultado da loteria será 9<br/><br/>Valor do hash **d14c, o resultado da loteria será 4<br/><br/>Se você gastar 100 para negociar, após deduzir a taxa de serviço de 2%, valor do contrato: 98<br/><br/>l Escolha verde: se o resultado mostrar 1,3,7,9, você obterá (98 * 2) = 196; se o resultado mostrar 5, você obterá (98 * 2) = 196<br/><br/>l Escolha vermelho: se o resultado mostrar 2,4,6,8, você obterá (98 * 2) = 196; se o resultado mostrar 0, você obterá (98 * 2) = 196<br/><br/>l escolha roxo: se o resultado mostrar 0 ou 5, você obterá (98 * 2) = 196<br/><br/>l selecione o número: se o resultado da abertura for o mesmo que o que você selecionou, você obterá (98 * 9) = 882<br/><br/>l escolha grande: se o resultado mostrar 5,6,7,8,9 você obterá (98 * 2) = 196<br/><br/>l selecione pequeno: se o resultado mostrar 0,1,2,3,4 você obterá (98 * 2) = 196',
    'WIN TRX彩票': 'WIN TRX Loteria',
    确认进入游戏吗: 'Tem certeza de que deseja entrar no jogo?',
    奖励兑换码: 'Código de presente',
    注册时间: 'Tempo de registro',
    '7 天全额存款': 'Depósito total de <span>{value}</span> dias',
    何时可以领取奖金: 'Tempo para receber o bônus',
    神秘奖金: 'Bônus misterioso',
    活动已过期: 'Atividade expirada',
    已领取: 'Recebido',
    首次存款: 'Depósito inicial',
    活动说明: 'Descrição da atividade',
    等级优惠: 'Desconto de nível',
    当前等级: 'Nível atual',
    铁: 'Ferro',
    青铜: 'Bronze',
    白银: 'Prata',
    黄金: 'Ouro',
    铂金: 'Platina',
    钻石: 'Diamante',
    近7天游戏营业额: 'Receita de jogo nos últimos {value} dias',
    未达成: 'Não cumprido',
    已申请: 'Aplicado',
    已收到: 'Recebido',
    保存: 'salvar',
    每周奖金: 'bônus semanal',
    领取时间: 'Horário de coleta',
    加载更多: 'Carregar mais',
    游戏大厅: 'Game Lobby',
    更多游戏: 'Mais jogos',
    底部描述:
        '{value} é operado pela empresa {value2} número de registro 142922, com endereço registrado em Zuikertuintjeweg Z/N (Zuikertuin Tower) Curaçao e é licenciado e autorizado pelo Governo de Curaçao. {value} opera sob a Licença Mestre do Provedor de Serviços de Jogos, N.V. Número da Licença: GLH-OCCHKTW065752688',
    底部描述2:
        ' <p>1. Este produto é para uso por usuários com 18 anos ou mais e é destinado apenas para fins de entretenimento.</p><p>2. Este jogo contém compras no aplicativo.</p><p>3. O fato de um jogador jogar ou ganhar em um jogo de apostas social não significa que ele ou ela ganhará em apostas com dinheiro real e jogos relacionados no futuro.</p>',
    版权声明: '{value} {value2}. Todos os direitos reservados. 18+',
    支付成功: 'Pagamento bem-sucedido',
    最大掉落: '{value} de cada vez Queda máxima',
    每天几次: '{value} vezes ao dia',
    当前输赢: 'Perda de corrente',
    当前可领金额: 'Valor atual disponível',
    上一期输赢: 'Perda da última emissão',
    上一期可领金额: 'Valor disponível para o período anterior',
    赎回基金表: 'Tabela de Fundo de Resgate',
    比赛失败: 'Falha no jogo',
    赎回费用: 'taxa de resgate',
    救援金: 'fundo de ajuda',
    本周补偿: 'Compensação para esta semana',
    本周盈利: 'Lucro esta semana',
    可获得补偿: 'Compensação disponível',
    本周的补偿将分配到: 'A compensação desta semana será distribuída às',
    每周报酬: 'Compensação Semanal',
    补偿: 'Compensação',
    累计投注: 'Apostas acumuladas',
    通过累积投注提升VIP等级: 'Aumente o nível VIP acumulando apostas',
    立即下载: 'Baixe agora',
    下载应用程序: 'Baixe o aplicativo',
    您要下载并安装APP吗: 'Você deseja baixar e instalar o aplicativo?',
    暂无可用手机号: 'Nenhum número de celular disponível ainda',
    '下载地址不存在，请稍后重试': 'Endereço de download não existe, por favor, tente novamente mais tarde',
    '下载已开始，请在通知栏查看下载进度': 'O download foi iniciado, por favor, verifique o progresso do download na barra de notificações',
    '下载失败，请稍后重试': 'O download falhou, por favor, tente novamente mais tarde',
    支付倒计时: 'Por favor, complete o pagamento em {value}',
    支付方式: 'Método de pagamento',
    钱包支付: 'Pagamento com carteira',
    取消充值申请: 'Cancelar solicitação de depósito',
    查看充值记录: 'Ver registro de depósito',
    打开App: 'Abrir aplicativo {value}',
    每日游戏收入: 'Receita de jogo por dia',
    签到奖金: 'Bônus de login',
    手机号首位不能为0: 'O número de telefone não pode começar com 0',
    真实姓名只能包含英文字母和空格: 'Nome real só pode conter letras e espaços',
    请输入正确的银行卡账号: 'Por favor, insira um número de conta bancária válido',
    请输入15位仅包含数字和字母的账号: 'Insira um número de conta de 15 caracteres com letras ou dígitos',
    请输入CLABE账号: 'Por favor, insira conta CLABE',
    请输入正确的CLABE账号: 'Por favor, insira uma conta CLABE válida',
    利息: 'Juros',
    转入金额必须大于: 'O valor de transferência deve ser maior que {value}',
    最小金额为: 'Mínimo {value}, apenas números inteiros',
    已转入: 'Carregado',
    年利率: 'Taxa de juros anual {value}%',
    周期: `<span><span style="color: var(--profit-color-hover);">{value}</span> Ciclo de Resolução (Máx. <span style="color: var(--profit-color-hover);"> {value2}</span>)</span>`,
    待处理: `<span> Pendente <span style="color: var(--profit-text-warning);"> {value} </span> (Concluído {value2}) </span>`,
    收取: 'Receber',
    累计收益: 'Receita Acumulada <span style="color: var(--profit-text-warning);"> {value}</span>',
    交易类型: 'Tipo de Transação',
    奖金: 'Bônus',
    详细资料: 'Perfil Detalhado',
    规则说明: 'Regras de Cuidado',
    解决周期: 'Ciclo de Resolução',
    转账金额: 'Valor da Transferência',
    当前时间: 'Hora Atual',
    存款利息结算: 'Após este depósito, o primeiro juro aparecerá em {value}',
    确认转账: 'Confirmação de Transferência',
    当前储蓄本: 'Livro de Poupança Atual',
    转出金额: 'Valor Transferido',
    本次循环的倒计时: 'Tempo de Contagem Regressiva para Este Ciclo',
    提取利息提示: 'Uma vez retirado, você perderá o juro deste ciclo!',
    确认提现: 'Confirmar saque',
    转入: 'Transferir',
    账户余额: 'Saldo da conta',
    提款最小金额: 'Valor mínimo de saque {value}',
    提取金额必须大于: 'O valor da extração deve ser maior que {value}',
    提取金额不能超过账户金额: 'O valor da extração não pode exceder o saldo da conta',
    提取成功: 'Saque bem-sucedido',
    提取失败: 'Saque falhou',
    转入成功: 'Transferência bem-sucedida',
    转入失败: 'Transferência falhou',
    无限: 'Ilimitado',
    时: '{value} Hora',
    分: '{value} Minuto',
    秒: '{value} Segundo',
    利息宝未开启: 'Juros não está aberto',
    已完成: 'Saque concluído',
    处理中: 'Saque em processamento',
    已取消: 'Saque cancelado',
    已提交: 'Saque enviado',
    审核中: 'Saque em revisão',
    出款中: 'Saque em retirada',
    出款失败: 'Saque falhou',
    已审核: 'Saque revisado',
    请输入UTR: 'Por favor, insira UTR',
    请输入数字和字母: 'Por favor, insira números e letras',
    补单成功: 'Saque atualizado com sucesso',
    补单失败: 'Saque atualização falhou',
    补单: 'Atualizar saque',
    请输入12位数字: 'Por favor, insira 12 dígitos',
    最多只能选择9个号码: 'Você só pode selecionar até 9 números',
    请选择支付方式: 'Por favor, selecione o método de pagamento',
    用户ID: 'ID do usuário/Número de telefone',
    总余额: 'Saldo total',
    提现余额: 'Saldo disponível para saque',
    请输入用户ID: 'Por favor, insira ID do usuário/Número de telefone',
    TelegramChannel: 'Canal de Telegram',
    真实姓名的长度不小于5个字符: 'O nome real deve ter pelo menos 5 caracteres',
    下载: 'Baixar',
    强度: 'Força',
    余额不足: 'Saldo insuficiente',
    客服: 'Suporte',
    有效投注总额: "Aposta Válida Total",
    盈亏总额: "Lucro e Perda Total",
    注册账户: 'Registrar conta',
    注册完成后可获得奖励: 'Após completar o registro, você pode <span class="intro-highlight">obter {value}</span> recompensas',
    
    // Login de terceiros relacionado
    第三方登录: 'Login de Terceiros',
    登录方式: 'Login com',
    
    // Relacionado ao carregamento da página de callback
    '正在处理登录...': 'Processando login...',
    '请稍候，即将为您跳转': 'Aguarde, redirecionando...',
    赠送中心: 'Centro de Presentes',
    截止日期: 'Data de término',
    返回顶部: 'Voltar ao topo',
    游戏: 'Jogos',
    搜索游戏: 'Pesquisar jogos',
    下注成功: 'Aposta bem-sucedida',
    下注失败: 'Aposta falhou',
    游戏历史: 'Histórico de jogos',
    期数: 'Período',
    存款宝箱: 'Tesouro de Depósito',
    归回累存: 'Acúmulo de depósitos de retorno',
    统计截至: 'Estatísticas até',
    剩余天数: 'Dias restantes',
    当前累计: 'Total acumulado atual',
    距: 'Até',
    还差: 'Ainda falta',
    当前可领取: 'Disponível para resgate',
    档: 'Nível',
    累计门槛: 'Meta acumulada',
    赠送金额: 'Valor do bônus',
    打码: 'Requisito de apostas',
    可提前领取: 'Pode ser resgatado antecipadamente. Após o resgate, não será possível alcançar níveis superiores',
    活动进行中: 'Evento em andamento',
    活动到期领取: 'Evento em andamento. A recompensa poderá ser resgatada após o término do evento',
    第几天: 'Dia {value}',
    已于第几天领取: 'Resgatado <strong>{value1}</strong> no dia {value}',
    几天: '{value} dias',
    回归每日首存: 'Primeiro depósito diário do usuário que retornou',
    今日时间: 'Horário de hoje',
    今日首笔存款: 'Primeiro depósito de hoje',
    可用奖金: 'Bônus disponível',
    奖金比例: 'Percentual do bônus',
    立即领取: 'Resgatar agora',
    去充值: 'Depositar',
    查看活动: 'Ver evento',
    再充值一点更划算: 'Deposite um pouco mais para uma recompensa melhor',
    当前档: 'Nível atual',
    冲刺档: 'Nível-alvo',
    冲: 'Adicionar',
    直接领取当前奖励: 'Resgatar {value} agora',
    活动结束: 'Evento encerrado',
    恭喜领取成功: 'Recompensa resgatada com sucesso',
    累计奖励已入账户: 'A recompensa acumulada {value} foi creditada',
    请完成打码流水后提现: 'Conclua o requisito de apostas antes do saque',
    知道了: 'Entendi',
    去下注: 'Apostar',
    充值后最高赠送: 'Bônus máximo após o depósito: {value}',
    倍数: 'Multiplicador',
    必须通过此页面充值才能获得多倍奖金: 'Você deve depositar por esta página para receber o bônus multiplicador',
    已领取宝箱金额: 'Recompensa do baú recebida',
    已领取翻倍奖励: 'Bônus de {value}x recebido',
    充值领取最高: 'Deposite para receber até {multiple}x, recompensa de {value}',
    说明: 'Instruções',
    翻倍充值说明: 'Instruções de depósito multiplicador',
    参与活动: 'Participar do evento',
    领取额外奖励: 'Resgatar recompensa extra',
    开始时间: 'Hora de início',
    流水倍数: 'Multiplicador de apostas',
    打开: 'Abrir',
    继续领取: 'Continuar resgate',
    翻倍领取: 'Resgatar bônus multiplicado',
};
